import React, { useState } from 'react';
import { userApi } from '../api';
import './ConsentModal.css';
import { Link } from 'react-router-dom';

interface ConsentModalProps {
  onClose: () => void;
  onPrivacyNoticeAccepted?: () => void;
  onSubmit?: (consented: boolean, privacy_notice_accepted: boolean) => void;
}

export const ConsentModal: React.FC<ConsentModalProps> = ({ onClose, onPrivacyNoticeAccepted, onSubmit }) => {
  const [dataConsent, setDataConsent] = useState(false);
  const [privacyNoticeAccepted, setPrivacyNoticeAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      
      if (onSubmit) {
        // New flow for new users - just call onSubmit with the data
        onSubmit(dataConsent, privacyNoticeAccepted);
      } else {
        // Existing flow for existing users - submit to API
        await userApi.submitConsent(dataConsent, privacyNoticeAccepted);
        if (privacyNoticeAccepted && onPrivacyNoticeAccepted) {
          onPrivacyNoticeAccepted();
        }
      }
      
      onClose();
    } catch (error) {
      console.error('Failed to submit consent:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="consent-modal-overlay">
      <div className="consent-modal">
        <h2>Data Usage Consent</h2>
        
        <div className="consent-content">
          <p>
          We'd like to use your anonymized and aggregated data from this game in academic publications. Participation is voluntary and you may play even if you do not consent to our use of your data. 
          For requests, please contact user.study@rsaconference.com. {' '}
            <Link to="/study-details" rel="noopener noreferrer" onClick={onClose}>Click here for details</Link>.
          </p>

          <div className="consent-checkboxes">
            <label className="checkbox-container required">
              <input
                type="checkbox"
                checked={privacyNoticeAccepted}
                onChange={(e) => setPrivacyNoticeAccepted(e.target.checked)}
              />
              <span>I acknowledge that I have reviewed the <Link to="/privacy-notice" rel="noopener noreferrer" onClick={onClose}>Privacy Notice</Link></span>
            </label>
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={dataConsent}
                onChange={(e) => setDataConsent(e.target.checked)}
              />
              <span>I consent to my data being used in academic publications</span>
            </label>
          </div>
        </div>

        <div className="consent-actions">
          <button
            className="submit-button"
            onClick={handleSubmit}
            disabled={isSubmitting || !privacyNoticeAccepted}
          >
            {isSubmitting ? 'Submitting...' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal; 